
import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import { GraphqlService } from 'src/app/services/graphql.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';



@Component({
  templateUrl: './analytics-dashboard.component.html'

})
export class AnalyticsDashboardComponent implements OnInit {

  cities: SelectItem[];

  cols: any[];

  patientCountData: any;
  consultationCountData: any;
  selectedCity: any;
  is_primary_provider: boolean = false;
  items: MenuItem[];

  pcount: number = 0;
  ucount: number = 0;
  dcount: number = 0;
  vcount: number = 0;
  scount: number = 0;
  ccount: number = 0;
  countrycount: number = 0;
  totalPatients: number = 0;
  totalCount: number = 0;

  data_count: any;
  patientCountryCount: any[] = [];


  constructor(
    private readonly graphqlService: GraphqlService,
    private readonly providerStateService: ProviderStateService
  ) { }

  async ngOnInit() {
    this.is_primary_provider = this.providerStateService.getIsPrimaryProvider();
    this.cols = [
      { field: 'doctorname', header: 'Doctor Name' },
      { field: 'noofconsultations', header: 'No. of Consultations' },
      { field: 'amount', header: 'Amount' }
    ];

    this.items = [
      { label: 'Save', icon: 'fa fa-check' },
      { label: 'Update', icon: 'fa fa-refresh' },
      { label: 'Delete', icon: 'fa fa-trash' }
    ];


    await this.getCounts();
    await this.getCountryPatientCount();
    await this.getSpecialityCount();
  }


  async getCounts() {
    this.graphqlService.getAllCounts().subscribe(
      (result) => {
        this.pcount = result.data['aggregatePatients'].reduce((sum, item) => sum + item.COUNT, 0) || 0;
        this.countrycount = result.data['findCountries'].length || 0;
        this.dcount = result.data['countDoctors'] || 0;
        this.vcount = result.data['countVendors'] || 0;
        this.scount = result.data['countSpeciality'] || 0;
        this.ccount = result.data['aggregateConsultation'][0]['totalCountOfConsultations'] || 0;
        this.ucount = result.data['aggregateUsers'][0]['totalCountOfUsers'] || 0;
      },
      (error) => {
        console.error('There was an error fetching the count from the API', error);
      }
    );
  }

  async getCountryPatientCount() {
    this.graphqlService.getAllCounts().subscribe(
      (result) => {
        this.data_count = result.data['aggregatePatients'];
  
        const data_copy = [...this.data_count];
  
        // Sort the countries by patient count
        data_copy.sort((a, b) => b.COUNT - a.COUNT);
  
        // Get the top 10 countries
        // const topCountries = data_copy.slice(0, 10);
        const topCountries = data_copy
  
        // Extract the labels and data for the chart
        const labels = topCountries.map(country => country.country.country_name);
        const data = topCountries.map(country => country.COUNT);
  
        // Calculate the total number of patients
        this.totalPatients = data.reduce((total, count) => total + count, 0);
  
        // Prepare the chart data
        this.patientCountData = {
          labels: labels,
          datasets: [
            {
              label: 'Top 10 Countries by Patient Count',
              data: data,
              backgroundColor: ['#ADD8E6', '#eedd82', '#FFA07A', '#B19CD9', '#2E78D2', '#b5651d', '#F08080', '#90EE90', '#FFB6C1', '#E6E6FA']
            }
          ]
        };
      },
      (error) => {
        console.error('There was an error fetching the count from the API', error);
      }
    );
  }
  

  async getSpecialityCount() {
    this.graphqlService.getAllCounts().subscribe(
      (result) => {
       
        const consultationData =
          result.data['aggregateConsultationAppointment'];

        const specialtyCountsMap = new Map<string | null, number>();

        consultationData.forEach((entry) => {
          const specialtyName =
            entry.d_specialty_type?.specialty_name || 'Others';
          const consultationCount = entry.COUNT;

          if (specialtyCountsMap.has(specialtyName)) {
            specialtyCountsMap.set(
              specialtyName,
              specialtyCountsMap.get(specialtyName)! + consultationCount
            );
          } else {
            specialtyCountsMap.set(specialtyName, consultationCount);
          }
        });

        const specialtyNames = Array.from(specialtyCountsMap.keys());
        const consultationCounts = Array.from(specialtyCountsMap.values());

        this.totalCount = consultationCounts.reduce(
          (total, count) => total + count,
          0
        );

        this.consultationCountData = {
          labels: specialtyNames,
          datasets: [
            {
              label: 'Consultation Count by Specialty',
              data: consultationCounts,
              backgroundColor: [
                '#ADD8E6',
                '#eedd82',
                '#FFA07A',
                '#B19CD9',
                '#2E78D2',
                '#b5651d',
                '#F08080',
                '#90EE90',
                '#FFB6C1',
                '#E6E6FA'
              ]
            }
          ]
        };

    
      },
      (error) => {
        console.error(
          'There was an error fetching the count from the API',
          error
        );
      }
    );
  }

}
